export const selectMany = <T>(items: Array<Array<T>>): Array<T> => Array.prototype.concat.apply([], items);
